import { render, staticRenderFns } from "./Mesas.vue?vue&type=template&id=2d353312&scoped=true"
import script from "./Mesas.vue?vue&type=script&lang=js"
export * from "./Mesas.vue?vue&type=script&lang=js"
import style0 from "./Mesas.vue?vue&type=style&index=0&id=2d353312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d353312",
  null
  
)

export default component.exports